import { __extends } from "tslib";
import EE from '@antv/event-emitter';
import { mix } from '../util/util';
var Base = /** @class */ (function (_super) {
    __extends(Base, _super);
    function Base(cfg) {
        var _this = _super.call(this) || this;
        /**
         * æ¯å¦è¢«éæ¯
         * @type {boolean}
         */
        _this.destroyed = false;
        var defaultCfg = _this.getDefaultCfg();
        _this.cfg = mix(defaultCfg, cfg);
        return _this;
    }
    /**
     * @protected
     * é»è®¤çéç½®é¡¹
     * @returns {object} é»è®¤çéç½®é¡¹
     */
    Base.prototype.getDefaultCfg = function () {
        return {};
    };
    // å®ç°æ¥å£çæ¹æ³
    Base.prototype.get = function (name) {
        return this.cfg[name];
    };
    // å®ç°æ¥å£çæ¹æ³
    Base.prototype.set = function (name, value) {
        this.cfg[name] = value;
    };
    // å®ç°æ¥å£çæ¹æ³
    Base.prototype.destroy = function () {
        this.cfg = {
            destroyed: true,
        };
        this.off();
        this.destroyed = true;
    };
    return Base;
}(EE));
export default Base;
//# sourceMappingURL=base.js.map